import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Privacy Policy
            </h1>
            
            <div className="prose prose-slate max-w-none">
              <p className="text-slate-600 mb-6">
                <strong>Last Updated:</strong> March 2026
              </p>
              
              <p className="text-slate-600 mb-6">
                Local Tradies Online ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website localtradiesonline.com.au.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">1. Information We Collect</h2>
              
              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Personal Information</h3>
              <p className="text-slate-600 mb-4">We may collect personal information that you voluntarily provide to us when you:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Register as a tradie on our platform</li>
                <li>Submit a quote request</li>
                <li>Contact us via our website</li>
                <li>Subscribe to our newsletter</li>
              </ul>
              <p className="text-slate-600 mb-4">This information may include:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Name and contact details (email, phone number)</li>
                <li>Business information (ABN, business name, services offered)</li>
                <li>Location information (suburb, postcode)</li>
                <li>Job descriptions and requirements</li>
              </ul>

              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Automatically Collected Information</h3>
              <p className="text-slate-600 mb-4">When you visit our website, we may automatically collect:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>IP address and browser type</li>
                <li>Device information</li>
                <li>Pages visited and time spent on our site</li>
                <li>Referring website addresses</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">2. How We Use Your Information</h2>
              <p className="text-slate-600 mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Connect customers with qualified tradies</li>
                <li>Process and manage quote requests</li>
                <li>Create and maintain tradie profiles</li>
                <li>Improve our website and services</li>
                <li>Send relevant communications and updates</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">3. Information Sharing</h2>
              <p className="text-slate-600 mb-4">We may share your information with:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li><strong>Tradies:</strong> When you submit a quote request, your contact details and job description are shared with relevant tradies</li>
                <li><strong>Service Providers:</strong> Third parties who assist us in operating our website and conducting our business</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              </ul>
              <p className="text-slate-600 mb-4">We do not sell your personal information to third parties.</p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">4. Data Security</h2>
              <p className="text-slate-600 mb-4">
                We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">5. Your Rights</h2>
              <p className="text-slate-600 mb-4">Under Australian Privacy Principles, you have the right to:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">6. Cookies</h2>
              <p className="text-slate-600 mb-4">
                We use cookies and similar technologies to enhance your experience on our website. For more information, please see our <a href="/cookies" className="text-[#f97316] hover:underline">Cookie Policy</a>.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">7. Changes to This Policy</h2>
              <p className="text-slate-600 mb-4">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">8. Contact Us</h2>
              <p className="text-slate-600 mb-4">
                If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
              </p>
              <p className="text-slate-600 mb-4">
                <strong>Email:</strong> privacy@localtradiesonline.com.au<br />
                <strong>Phone:</strong> 0431 775 771
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
